import React, { useEffect } from "react"
import { useQuery } from "react-query"
import Select from "react-select"
import axios from "axios"
import cn from "classnames"
import customStyles from "./styles"

type LOADING_NUMBER = {
  terminal_label: string
  supplier_label: string
  supplier: number
  terminal: any
}

type RECORDER = { [key: string]: { [key: string]: boolean } }

type OPTIONS = {
  [key: string]: {
    label: string
    id: number
    value: number
    terminal_label: string
    source_name: string
    terminal: any
  }[]
}

const fetchSources = (productId?: number, terminal?: number) => async () => {
  if (!productId) return
  let url = "suppliers/terminals/"
  if (productId) url += `?product=${productId}`
  if (terminal) url += `&terminal=${terminal}`
  const { data } = await axios.get(url)
  const temp = {} as RECORDER
  const options = {} as OPTIONS
  data.map((item: LOADING_NUMBER) => {
    if (terminal && item.terminal !== terminal) return
    if (temp?.[item.terminal_label]?.[item.supplier_label]) return
    temp[item.terminal_label] = temp?.[item.terminal_label] ?? {}
    temp[item.terminal_label][item.supplier_label] = true

    options[item.terminal_label] = options[item.terminal_label] ?? []
    options[item.terminal_label].push({
      label: item.supplier_label,
      id: item.supplier,
      value: item.supplier,
      terminal: item.terminal,
      terminal_label: item.terminal_label,
      source_name: `${item.terminal_label}: ${item.supplier_label}`,
    })
  })

  const output = Object.entries(temp).map(([key, v]) => {
    options[key].sort((a: any, b: any) =>
      a.source_name < b.source_name ? -1 : 1
    )
    return {
      label: key,
      options: options[key],
    }
  })

  return output
}

const SourcePicker = (props: {
  selected?: any
  product?: number
  terminal?: number
  needsTerminal?: boolean
  flush?: boolean
  placeholder?: string
  className?: string
  label?: string
  isClearable?: boolean
  onSelect?: (item: any) => void
  styles?: any
}) => {
  const dataArray = ["sources", props.product]
  if (props.terminal) dataArray.push(props.terminal)
  const { data, isLoading, refetch, isFetching } = useQuery(
    dataArray,
    fetchSources(props.product, props.terminal),
    { cacheTime: 10000, refetchOnWindowFocus: false }
  )

  if (props.needsTerminal && !props.terminal) return <React.Fragment />
  if (!props.product) return <React.Fragment />
  if (isLoading || isFetching) return <React.Fragment />
  const defaultValue = data
    ?.flatMap((x) => x.options)
    ?.filter(
      (y) =>
        `${y.id}_${y.terminal}` ===
        `${props.selected?.supplier}_${props.selected?.terminal}`
    )[0]

  const style = props.flush ? { marginRight: 0 } : {}
  return (
    <div className={cn("flex-c-box", props.className)}>
      {!props.label ? null : (
        <>
          <span style={{ color: "#486f88", fontWeight: "bold" }}>
            {props.label}
          </span>
          <div style={{ marginTop: 4 }} />
        </>
      )}

      <Select
        placeholder={props.placeholder ?? "Choose Source"}
        options={data}
        isClearable={props.isClearable}
        onChange={props.onSelect}
        styles={props?.styles ? props?.styles : customStyles(style)}
        value={defaultValue}
      />
    </div>
  )
}

export default SourcePicker
